import React, { useState, ChangeEvent, FormEvent } from "react";
import { Grid, TextField, Button } from "@mui/material";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

interface ForgotPasswordForm {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();

  const [value, setValue] = useState<ForgotPasswordForm>({
    email: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  const changeHandler = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setValue({ ...value, [e.target.name]: e.target.value });
    validator.showMessages();
  };

  const submitForm = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    if (validator.allValid()) {
      if (!value.email.trim()) {
        toast.error("Email field cannot be empty!");
        return;
      }

      setValue({ email: "" });
      validator.hideMessages();
      toast.success("Password reset link sent successfully!");
      navigate("/login");
    } else {
      validator.showMessages();
      toast.error("Please enter a valid email address!");
    }
  };

  return (
    <Grid className="loginWrapper">
      <Grid className="loginForm">
        <h2>Forgot Password</h2>
        <p>Reset your account password</p>

        <form onSubmit={submitForm} noValidate>
          <Grid container spacing={3}>
            {/* Email Input */}
            <Grid item xs={12}>
              <TextField
                className="inputOutline"
                fullWidth
                placeholder="E-mail"
                value={value.email}
                variant="outlined"
                name="email"
                label="E-mail"
                InputLabelProps={{
                  shrink: true,
                }}
                onBlur={changeHandler}
                onChange={changeHandler}
              />
              {validator.message("email", value.email, "required|email")}
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Grid className="formFooter">
                <Button
                  fullWidth
                  className="cBtn cBtnLarge cBtnTheme"
                  type="submit"
                >
                  Resend Password
                </Button>
              </Grid>

              {/* Social Buttons */}
              <Grid className="loginWithSocial">
                <Button className="facebook" aria-label="Login with Facebook">
                  <i className="fa fa-facebook"></i>
                </Button>
                <Button className="twitter" aria-label="Login with Twitter">
                  <i className="fa fa-twitter"></i>
                </Button>
                <Button className="linkedin" aria-label="Login with LinkedIn">
                  <i className="fa fa-linkedin"></i>
                </Button>
              </Grid>

              {/* Redirect Link */}
              <p className="noteHelp">
                Already have an account?{" "}
                <Link to="/login">Return to Sign In</Link>
              </p>
            </Grid>
          </Grid>
        </form>

        {/* Decorative Shape */}
        <div className="shape-img">
          <i className="fi flaticon-honeycomb"></i>
        </div>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
